import React from 'react';
import colors from 'theme/Colors.module.scss';
import { Spinner, Flex, Center, Box } from '@chakra-ui/react';

const Loading = ({
  type,
  height,
  thickness,
  color = colors.primary900,
  size,
}) => {
  if (type === 'fullpage') {
    return (
      <Center h={height || `calc(100vh - 100px)`}>
        <Box textAlign="center">
          <Spinner
            thickness={thickness || '4px'}
            color={color}
            size={size || 'xl'}
          />
        </Box>
      </Center>
    );
  }
  return (
    <Flex align="center" justify="center" w="100%" height={height}>
      <Spinner
        thickness={thickness || '3px'}
        color={color}
        size={size || 'md'}
      />
    </Flex>
  );
};

export default Loading;
